import { combineReducers } from 'redux';

const feedbackActInfoInitialState = {
  loadStatus: 0,
  data: null,
};

const checkFeedbackLimitInitialState = {
  saveStatus: 0,
  data: null,
};

const feedbackEditInitialState = {
  input: {
    images: [],
    content: '',
  },
  saveStatus: 0,
  data: null,
};

const mineFeedbackInfoInitialState = {
  loadStatus: 0,
  data: null,
};

const feedbackDetailInitialState = {
  loadStatus: 0,
  data: null,
};

const feedbackMasterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    size: 20,
  },
};

function feedbackActInfoReducer(state = feedbackActInfoInitialState, action) {
  switch (action.type) {
    case 'LOAD_NEW_FEEDBACK_ACT_INFO': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_NEW_FEEDBACK_ACT_INFO_COMPLETION': {
      const { error, data } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function checkFeedbackLimitReducer(
  state = checkFeedbackLimitInitialState,
  action
) {
  switch (action.type) {
    case 'CHECK_NEW_FEEDBACK_LIMIT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'CHECK_NEW_FEEDBACK_LIMIT_COMPLETION': {
      const { error, data } = action;
      if (error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      return {
        ...state,
        saveStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function feedbackEditReducer(state = feedbackEditInitialState, action) {
  switch (action.type) {
    case 'SYNC_NEW_FEEDBACK_EDIT_INPUT': {
      return {
        ...state,
        input: {
          ...(action.reset ? feedbackEditInitialState.input : state.input),
          ...action.input,
        },
      };
    }

    case 'EDIT_NEW_FEEDBACK': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'EDIT_NEW_FEEDBACK_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
        data: action.data,
      };
    }

    default:
      return state;
  }
}

function feedbackMasterReducer(state = feedbackMasterInitialState, action) {
  switch (action.type) {
    case 'LOAD_NEW_FEEDBACK_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_NEW_FEEDBACK_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(feedback => feedback.id);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function mineFeedbackInfoReducer(state = mineFeedbackInfoInitialState, action) {
  switch (action.type) {
    case 'LOAD_OWN_NEW_FEEDBACK_INFO': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_OWN_NEW_FEEDBACK_INFO_COMPLETION': {
      const { error, data } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function feedbackDetailReducer(state = feedbackDetailInitialState, action) {
  switch (action.type) {
    case 'LOAD_NEW_FEEDBACK_DETAIL': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_NEW_FEEDBACK_DETAIL_COMPLETION': {
      const { error, data } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function feedbacksReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_NEW_FEEDBACK_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      const feedbacks = action.list.reduce(
        (obj, feedback) => {
          const id = feedback.id;

          if (id) {
            obj[id] = { ...obj[id], ...feedback };
          }
          return obj;
        },
        { ...state }
      );

      return feedbacks;
    }

    case 'LOAD_OWN_NEW_FEEDBACK_INFO_COMPLETION': {
      const { data, error } = action;

      if (error || !data) {
        return state;
      }

      return {
        ...state,
        [data.id]: { ...state[data.id], ...data },
      };
    }

    case 'LOAD_NEW_FEEDBACK_DETAIL_COMPLETION': {
      const { data, error } = action;

      if (error || !data) {
        return state;
      }

      return {
        ...state,
        [data.id]: { ...state[data.id], ...data },
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  actInfo: feedbackActInfoReducer,
  checkLimit: checkFeedbackLimitReducer,
  edit: feedbackEditReducer,
  mineFeedback: mineFeedbackInfoReducer,
  detail: feedbackDetailReducer,
  master: feedbackMasterReducer,
  feedbacks: feedbacksReducer,
});
